import { URL_CONTEXTS } from 'common/constants/constants';
import {
  ITERATION_SUMMARY_TITLE,
  EXCLUDE_SECTIONS
} from './IterationSummary.consts';

export const copyLink = async ({ iterationId, teamId, organizationId }) => {
  const { origin, pathname, search } = window.location;
  const searchParams = new URLSearchParams(search);
  searchParams.set('context', URL_CONTEXTS.TEAM_ITERATION);
  searchParams.set('teams', teamId);
  searchParams.set('iteration_id', iterationId);
  searchParams.set('oid', organizationId);
  searchParams.set('utm_source', 'share_link');
  searchParams.set('utm_medium', 'linweb');
  searchParams.set('utm_campaign', 'iteration_summary');
  searchParams.set('utm_content', iterationId);
  const url = `${origin}${pathname}?${searchParams.toString()}`;
  await navigator.clipboard.writeText(url);
};

export const copyAsMarkdown = async ({ data, iterationRange }) => {
  const normalizeText = (text: string) => {
    return text.trim();
  };
  const markdown = `# ✨ ${ITERATION_SUMMARY_TITLE} ${
    data?.iteration_name
  } (${iterationRange})
        
${data?.accomplishments
  .filter(
    item => !item.type || (item.type && !EXCLUDE_SECTIONS.includes(item.type))
  )
  ?.map(
    (accomplishment: { content: string }) =>
      `${normalizeText(accomplishment.content)}`
  )
  .join('\n\n')}
`;
  await navigator.clipboard.writeText(markdown);
};
